import React, { useEffect } from "react";
import { Box } from "@mui/material";

// Importa los componentes que acabas de crear
import QuienesSomos from "../components/Nosotros/QuienesSomos";
import MisionVision from "../components/Nosotros/MisionVision";
import NuestroEquipo from "../components/Nosotros/NuestroEquipo";

export default function NosotrosPage() {
  useEffect(() => {
    // Para que al cambiar de ruta, la página suba automáticamente
    window.scrollTo(0, 0);
    document.title = "Nosotros | Eléctrica GRM";
  }, []);

  return (
    <Box>
      <QuienesSomos />
      <MisionVision />
      <NuestroEquipo />
    </Box>
  );
}
